import { useEffect, useState } from "react";
import { FastForward, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, fmt, formatApiError } from "../../lib/api";
import { ChannelBadge, StatusBadge } from "../../components/StatusBadge";

const FILTERS = ["all", "shop", "ebay", "tiktok"];

export default function OrdersAdminPage() {
  const [orders, setOrders] = useState([]);
  const [channel, setChannel] = useState("all");
  const [advancing, setAdvancing] = useState(null);

  const load = () => api.get("/admin/orders", { params: { channel } }).then((r) => setOrders(r.data.orders));
  useEffect(() => { load(); }, [channel]);

  const advance = async (id) => {
    setAdvancing(id);
    try {
      await api.post(`/admin/orders/${id}/advance`);
      toast.success("Fulfillment advanced (MOCKED)");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
    setAdvancing(null);
  };

  return (
    <div data-testid="admin-orders-page">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="eyebrow">Fulfilment</p>
          <h1 className="font-heading text-2xl font-bold text-white">Orders — all channels</h1>
        </div>
        <div className="flex gap-2">
          {FILTERS.map((f) => (
            <button
              key={f}
              data-testid={`orders-filter-${f}`}
              onClick={() => setChannel(f)}
              className={`rounded-full border px-4 py-1.5 text-xs font-medium capitalize ${
                channel === f ? "border-amber-400 bg-amber-400/15 text-amber-300" : "border-white/10 text-slate-400"
              }`}
            >
              {f === "all" ? "All channels" : f === "tiktok" ? "TikTok Shop" : f}
            </button>
          ))}
        </div>
      </div>
      <div className="card-surface overflow-x-auto">
        <table className="w-full min-w-[900px] text-sm">
          <thead>
            <tr className="border-b border-white/[0.08] text-left text-xs uppercase tracking-wider text-slate-500">
              <th className="px-5 py-3">Order</th>
              <th className="px-5 py-3">Customer</th>
              <th className="px-5 py-3">Items</th>
              <th className="px-5 py-3">Total</th>
              <th className="px-5 py-3">Channel</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3">Tracking</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-white/[0.04] hover:bg-white/[0.02]" data-testid={`order-row-${o.order_number}`}>
                <td className="px-5 py-3">
                  <p className="font-mono text-xs font-semibold text-amber-300">{o.order_number}</p>
                  <p className="text-[11px] text-slate-600">{o.created_at.slice(0, 10)}</p>
                </td>
                <td className="px-5 py-3">
                  <p className="text-white">{o.customer.name}</p>
                  <p className="text-[11px] text-slate-500">{o.customer.email}</p>
                </td>
                <td className="px-5 py-3 text-xs text-slate-400">{o.items.map((i) => `${i.name} ×${i.qty}`).join(", ")}</td>
                <td className="px-5 py-3 font-semibold text-white">{fmt(o.total || o.subtotal)}</td>
                <td className="px-5 py-3"><ChannelBadge channel={o.channel} /></td>
                <td className="px-5 py-3"><StatusBadge status={o.status} /></td>
                <td className="px-5 py-3 font-mono text-[11px] text-slate-400">{o.fulfillment.tracking_number || "—"}</td>
                <td className="px-5 py-3">
                  {o.payment_status === "paid" && o.status !== "delivered" && (
                    <button
                      data-testid={`order-advance-${o.order_number}`}
                      onClick={() => advance(o.id)}
                      disabled={advancing === o.id}
                      className="flex items-center gap-1 rounded-lg border border-white/10 px-2.5 py-1.5 text-[11px] text-slate-300 hover:border-amber-400/50 hover:text-amber-300 disabled:opacity-50"
                    >
                      {advancing === o.id ? <Loader2 size={11} className="animate-spin" /> : <FastForward size={11} />} Advance
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {orders.length === 0 && <p className="p-8 text-center text-sm text-slate-500" data-testid="orders-empty">No orders for this filter.</p>}
      </div>
    </div>
  );
}
